import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import './RDBreadcrumb.scss';

const RDBreadcrumb = ({ breadcrumbItems }) => (
  <Breadcrumb>
    {breadcrumbItems.map((breadcrumb) => {
      const { key, value, last } = breadcrumb;
      return (
        <Breadcrumb.Item key={key}>{last ? value : <Link to={key}> {value}</Link>}</Breadcrumb.Item>
      );
    })}
  </Breadcrumb>
);

RDBreadcrumb.defaultProps = {};

RDBreadcrumb.propTypes = {
  /** Breadcrumb items */
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      last: PropTypes.bool,
    }),
  ).isRequired,
};

export default RDBreadcrumb;
